export interface TranslationKeys {
    loading: string
    redirectingToLogin: string
    callEndpointAgain: string
    language: string
    user: string
    message: string
    error: string
    logout: string
    navHome: string
    navSettings: string
    navTrolleys: string
    devicesTitle: string
    deviceViewInventory: string
    inventoryTitle: string
    kpiToolsPresent: string
    kpiToolsRemoved: string
    kpiFoamsMonitored: string
    kpiIsOnline: string
    drawerLabel: string
    drawerComplete: string
    drawerIncomplete: string
    foamSingle: string
    foamDouble: string
    toolsWord: string
    backToInventory: string
    toolPresent: string
    toolAbsent: string
    twinTitle: string
    twinAdminsOnly: string
    twinSelectNode: string
    twinCartLabel: string
    twinIpc: string
    twinBattery: string
    twinBoardLabel: string
    twinStatusUserTest: string
    twinDetailTrolley: string
    twinDetailPrototype: string
    twinDetailDrawers: string
    twinDetailFoams: string
    twinDetailTools: string
    twinDetailStatus: string
    twinDetailSerial: string
    twinDetailOs: string
    twinDetailController: string
    twinDetailFirmware: string
    twinDetailCharge: string
    twinDetailCycles: string
    twinDetailPosition: string
    twinDetailBoards: string
    twinDetailDrawer: string
    twinDetailBoardId: string
    twinDetailMcu: string
    twinDetailType: string
    twinDetailMlModels: string
    twinDetailId: string
    navFoams: string
    foamsTitle: string
    foamsNew: string
    foamsEmpty: string
    foamsAdminsOnly: string
    foamImage: string
    foamName: string
    foamSize: string
    foamToolsHeading: string
    foamActions: string
    foamEdit: string
    foamDelete: string
    foamEditTitle: string
    foamUploadImage: string
    foamPlaceHint: string
    foamNoImage: string
    foamToolNameDe: string
    foamToolNameEn: string
    foamCoordX: string
    foamCoordY: string
    foamRemoveTool: string
    foamSave: string
    foamCancel: string
    foamSaved: string
    foamDeleted: string
    foamDeleteTitle: string
    foamDeleteMessage: string
    foamValidationName: string
    foamValidationImage: string
    foamModelsTitle: string
    foamModelsEmpty: string
    foamModelsRevision: string
    foamModelsLatest: string
    foamModelsFileName: string
    foamModelsFileKind: string
    foamModelsFileSize: string
    foamModelsUpload: string
    foamModelsUploadHint: string
    foamModelsNote: string
    foamModelsPublish: string
    foamModelsPublished: string
    foamModelsSelected: string
    foamModelsClear: string
    foamModelsDownload: string
    foamModelsRemove: string
    foamModelsRemoveTitle: string
    foamModelsRemoveMessage: string
    foamModelsHistoryHint: string
    foamModelsReadOnly: string
    foamModelsSaveFirst: string
    foamModelsFileCount: string
    foamValidationTools: string
    foamImportAction: string
    foamImportTitle: string
    foamImportJsonLabel: string
    foamImportImageLabel: string
    foamImportSummary: string
    foamImportUnitLabel: string
    foamImportUnitAuto: string
    foamImportUnitFraction: string
    foamImportUnitPixel: string
    foamImportDetectedUnit: string
    foamImportErrorJson: string
    foamImportErrorNoTools: string
    foamImportErrorImage: string
    foamImportContinue: string
    settingsTitle: string
    settingsDisplayName: string
    settingsEmail: string
    settingsLanguage: string
    settingsSave: string
    settingsSaved: string
    notFoundTitle: string
    notFoundMessage: string
    notFoundBack: string
    validationDisplayNameMin: string
    validationEmailInvalid: string
    authErrorTitle: string
    trolleysTitle: string
    trolleysNew: string
    trolleysEmpty: string
    trolleysAdminsOnly: string
    trolleyNotFound: string
    trolleyColId: string
    trolleyColName: string
    trolleyColDevice: string
    trolleyColDrawers: string
    trolleyColFoams: string
    trolleyColUser: string
    trolleyColActions: string
    trolleyColIsOnline: string
    trolleyEdit: string
    trolleyDelete: string
    trolleyDeleteTitle: string
    trolleyDeleteMessage: string
    trolleyDeleted: string
    trolleyCreated: string
    trolleySaved: string
    trolleyWizardCreateTitle: string
    trolleyWizardEditTitle: string
    trolleyStepBasics: string
    trolleyStepDrawers: string
    trolleyStepReview: string
    trolleyFieldId: string
    trolleyFieldName: string
    trolleyFieldDevice: string
    trolleyFieldUser: string
    trolleyFieldDrawerCount: string
    trolleyNext: string
    trolleyBack: string
    trolleyCreate: string
    trolleySave: string
    trolleyCancel: string
    trolleyAddFoam: string
    trolleyRemoveFoam: string
    trolleyNoLibraryFoams: string
    trolleyNoAssignments: string
    trolleyTabInventory: string
    trolleyTabTwin: string
    trolleyTabShell: string
    trolleyFieldSshHost: string
    trolleyFieldSshHostHint: string
    trolleyValidationSshHost: string
    shellAdminsOnly: string
    shellNoAddress: string
    shellConnect: string
    shellDisconnect: string
    shellStatus_idle: string
    shellStatus_connecting: string
    shellStatus_connected: string
    shellStatus_closed: string
    shellStatus_error: string
    trolleyDetailDevice: string
    trolleyDetailUser: string
    trolleyUnnamed: string
    trolleyMissingConfig: string
    trolleyNeedsConfigTitle: string
    trolleyNeedsConfigBody: string
    trolleyValidationId: string
    trolleyValidationName: string
    trolleyValidationDevice: string
    trolleyValidationUser: string
    trolleyValidationDrawerCount: string
    trolleyDrawerSlots: string
    trolleyDrawerFull: string
    trolleyNoFittingFoams: string
    trolleyBoardLabel: string
    trolleyBoardTooltip: string
    trolleyDoubleAnchor: string
    trolleyFoamDouble: string
    trolleyNoReportedHardware: string
    cancel: string
    add: string
    navTemplates: string
    templatesTitle: string
    templatesEmpty: string
    templateSaveAction: string
    templateApplyAction: string
    templateExportAction: string
    templateImportAction: string
    templateSaveTitle: string
    templateApplyTitle: string
    templateApplyLabel: string
    templateNameLabel: string
    templateNoneForDrawerCount: string
    templateSaved: string
    templateApplied: string
    templateImported: string
    templateDeleted: string
    templateDeleteTitle: string
    templateDeleteMessage: string
    templateImportUnresolved: string
    templateImportInvalid: string
}

const en: TranslationKeys = {
    loading: 'Loading...',
    redirectingToLogin: 'Redirecting to login...',
    callEndpointAgain: 'Call endpoint again',
    language: 'Language',
    user: 'User',
    message: 'Message',
    error: 'An error occurred',
    logout: 'Logout',
    navHome: 'Home',
    navSettings: 'Settings',
    navTrolleys: 'Trolleys',
    devicesTitle: 'Devices',
    deviceViewInventory: 'View inventory',
    inventoryTitle: 'Inventory',
    kpiToolsPresent: 'Number of Tools',
    kpiToolsRemoved: 'Tools removed',
    kpiFoamsMonitored: 'Number of Foams',
    kpiIsOnline: 'State',
    drawerLabel: 'Drawer {{number}}',
    drawerComplete: 'complete',
    drawerIncomplete: 'incomplete',
    foamSingle: 'Single',
    foamDouble: 'Double',
    toolsWord: 'tools',
    backToInventory: 'Back to inventory',
    toolPresent: 'present',
    toolAbsent: 'removed',
    twinTitle: 'Digital twin',
    twinAdminsOnly: 'This view is available to administrators only.',
    twinSelectNode: 'Select a node to see its details.',
    twinCartLabel: 'Tool cart {{id}}',
    twinIpc: 'Industrial PC',
    twinBattery: 'Battery',
    twinBoardLabel: 'Board {{id}}',
    twinStatusUserTest: 'User test',
    twinDetailTrolley: 'Trolley ID',
    twinDetailPrototype: 'Prototype',
    twinDetailDrawers: 'Drawers',
    twinDetailFoams: 'Foams',
    twinDetailTools: 'Tools',
    twinDetailStatus: 'Status',
    twinDetailSerial: 'Serial number',
    twinDetailOs: 'OS version',
    twinDetailController: 'Controller app',
    twinDetailFirmware: 'Firmware',
    twinDetailCharge: 'Charge',
    twinDetailCycles: 'Charge cycles',
    twinDetailPosition: 'Position',
    twinDetailBoards: 'Electronics boards',
    twinDetailDrawer: 'Drawer',
    twinDetailBoardId: 'Board ID',
    twinDetailMcu: 'Microcontrollers',
    twinDetailType: 'Type',
    twinDetailMlModels: 'ML models',
    twinDetailId: 'Tool ID',
    navFoams: 'Foams',
    foamsTitle: 'Foam library',
    foamsNew: 'New foam',
    foamsEmpty: 'No foams yet. Create one to get started.',
    foamsAdminsOnly: 'This view is available to administrators only.',
    foamImage: 'Image',
    foamName: 'Foam name',
    foamSize: 'Size',
    foamToolsHeading: 'Tools',
    foamActions: 'Actions',
    foamEdit: 'Edit',
    foamDelete: 'Delete',
    foamEditTitle: 'Edit foam',
    foamUploadImage: 'Upload image',
    foamPlaceHint: 'Click on the image to place a tool marker, or drag a point to move it.',
    foamNoImage: 'Upload an image to start placing tools.',
    foamToolNameDe: 'Name (DE)',
    foamToolNameEn: 'Name (EN)',
    foamCoordX: 'X',
    foamCoordY: 'Y',
    foamRemoveTool: 'Remove tool',
    foamSave: 'Save foam',
    foamCancel: 'Cancel',
    foamSaved: 'Foam saved',
    foamDeleted: 'Foam deleted',
    foamDeleteTitle: 'Delete foam',
    foamDeleteMessage: 'This permanently removes the foam and its tools.',
    foamValidationName: 'A foam name is required.',
    foamValidationImage: 'An image is required.',
    foamModelsTitle: 'Model files',
    foamModelsEmpty: 'No model files yet. Upload a set to publish the first revision.',
    foamModelsRevision: 'Revision {{number}}',
    foamModelsLatest: 'latest',
    foamModelsFileName: 'File',
    foamModelsFileKind: 'Type',
    foamModelsFileSize: 'Size',
    foamModelsUpload: 'Add files',
    foamModelsUploadHint: 'Drop JSON files here, or use “Add files”.',
    foamModelsNote: 'What changed? (optional)',
    foamModelsPublish: 'Publish revision',
    foamModelsPublished: 'Revision {{number}} published.',
    foamModelsSelected: '{{count}} file(s) ready to publish',
    foamModelsClear: 'Clear',
    foamModelsDownload: 'Download',
    foamModelsRemove: 'Remove',
    foamModelsRemoveTitle: 'Remove file?',
    foamModelsRemoveMessage: 'This publishes a new revision without “{{name}}”. Earlier revisions keep the file.',
    foamModelsHistoryHint: 'Revisions are immutable — carts in the field keep the files they downloaded.',
    foamModelsReadOnly: 'You are viewing an older revision. Switch to the latest to make changes.',
    foamModelsSaveFirst: 'Save the foam before adding model files.',
    foamModelsFileCount: '{{files}} files · {{size}}',
    foamValidationTools: 'Place at least one tool and give it a German name.',
    foamImportAction: 'Import from JSON',
    foamImportTitle: 'Import foam from JSON',
    foamImportJsonLabel: 'Choose foam JSON',
    foamImportImageLabel: 'Choose image',
    foamImportSummary: '{{count}} tools detected',
    foamImportUnitLabel: 'Coordinate units',
    foamImportUnitAuto: 'Auto-detect',
    foamImportUnitFraction: 'Fractions (0–1)',
    foamImportUnitPixel: 'Pixels',
    foamImportDetectedUnit: 'Detected: {{unit}}',
    foamImportErrorJson: 'That file is not a valid foam JSON.',
    foamImportErrorNoTools: 'The foam JSON has no tools.',
    foamImportErrorImage: 'Could not read the image.',
    foamImportContinue: 'Continue',
    settingsTitle: 'Profile Settings',
    settingsDisplayName: 'Display Name',
    settingsEmail: 'Email',
    settingsLanguage: 'Language',
    settingsSave: 'Save changes',
    settingsSaved: 'Saved successfully',
    notFoundTitle: 'Page not found',
    notFoundMessage: 'The page you are looking for does not exist or has been moved.',
    notFoundBack: 'Back to home',
    validationDisplayNameMin: 'Display name must be at least 2 characters',
    validationEmailInvalid: 'Must be a valid email address',
    authErrorTitle: 'Authentication service unavailable',
    trolleysTitle: 'Trolleys',
    trolleysNew: 'New trolley',
    trolleysEmpty: 'No trolleys yet. Create one to get started.',
    trolleysAdminsOnly: 'This view is available to administrators only.',
    trolleyNotFound: 'Trolley not found.',
    trolleyColId: 'ID',
    trolleyColName: 'Name',
    trolleyColDevice: 'Device',
    trolleyColDrawers: 'Drawers',
    trolleyColFoams: 'Foams',
    trolleyColUser: 'Assigned user',
    trolleyColActions: 'Actions',
    trolleyColIsOnline: 'Online',
    trolleyEdit: 'Edit',
    trolleyDelete: 'Delete',
    trolleyDeleteTitle: 'Delete trolley',
    trolleyDeleteMessage: 'This permanently removes the trolley and its drawer assignments.',
    trolleyDeleted: 'Trolley deleted',
    trolleyCreated: 'Trolley created',
    trolleySaved: 'Trolley saved',
    trolleyWizardCreateTitle: 'New trolley',
    trolleyWizardEditTitle: 'Edit trolley',
    trolleyStepBasics: 'Basics',
    trolleyStepDrawers: 'Drawers',
    trolleyStepReview: 'Review',
    trolleyFieldId: 'Trolley ID',
    trolleyFieldName: 'Name',
    trolleyFieldDevice: 'Device ID',
    trolleyFieldUser: 'Assigned user',
    trolleyFieldDrawerCount: 'Drawer count',
    trolleyNext: 'Next',
    trolleyBack: 'Back',
    trolleyCreate: 'Create trolley',
    trolleySave: 'Save changes',
    trolleyCancel: 'Cancel',
    trolleyAddFoam: 'Add foam',
    trolleyRemoveFoam: 'Remove {{name}}',
    trolleyNoLibraryFoams: 'No foams in the library yet. Create one under Foams first.',
    trolleyNoAssignments: 'No foams assigned.',
    trolleyTabInventory: 'Inventory',
    trolleyTabTwin: 'Digital twin',
    trolleyTabShell: 'Shell',
    trolleyFieldSshHost: 'Shell address (optional)',
    trolleyFieldSshHostHint: 'WireGuard IP or hostname. Leave empty to disable remote shell access for this cart.',
    trolleyValidationSshHost: 'Only letters, digits and . _ : - are allowed.',
    shellAdminsOnly: 'This view is available to administrators only.',
    shellNoAddress: 'No shell address is configured for this cart. Add one in the cart settings to enable remote access.',
    shellConnect: 'Connect',
    shellDisconnect: 'Disconnect',
    shellStatus_idle: 'Not connected',
    shellStatus_connecting: 'Connecting…',
    shellStatus_connected: 'Connected',
    shellStatus_closed: 'Session ended',
    shellStatus_error: 'Connection failed',
    trolleyDetailDevice: 'Device',
    trolleyDetailUser: 'Assigned user',
    trolleyUnnamed: 'Unnamed trolley',
    trolleyMissingConfig: 'Config missing',
    trolleyNeedsConfigTitle: 'This trolley needs configuration',
    trolleyNeedsConfigBody:
        'The device registered itself but has no configuration yet. Assign a name, user, and drawer foams to finish setting it up.',
    trolleyValidationId: 'A trolley ID is required.',
    trolleyValidationName: 'A name is required.',
    trolleyValidationDevice: 'A device ID is required.',
    trolleyValidationUser: 'An assigned user is required.',
    trolleyValidationDrawerCount: 'Drawer count must be at least 1.',
    trolleyDrawerSlots: '{{used}} / {{max}} Slots used',
    trolleyDrawerFull: 'Drawer full',
    trolleyNoFittingFoams: 'No more fitting foams',
    trolleyBoardLabel: "Board {{number}}",
    trolleyBoardTooltip: "Board {{number}} (Serial: {{usb}})",
    trolleyDoubleAnchor: "Boards {{first}}–{{second}}",
    trolleyFoamDouble: "Double",
    trolleyNoReportedHardware: "Trolley has not reported its hardware yet — please wait for the device to register.",
    cancel: "Cancel",
    add: "Add",
    navTemplates: 'Templates',
    templatesTitle: 'Configuration templates',
    templatesEmpty: 'No templates yet. Save one from a trolley to get started.',
    templateSaveAction: 'Save as template',
    templateApplyAction: 'Apply template',
    templateExportAction: 'Export',
    templateImportAction: 'Import',
    templateSaveTitle: 'Save configuration as template',
    templateApplyTitle: 'Apply a template',
    templateApplyLabel: 'Template',
    templateNameLabel: 'Template name',
    templateNoneForDrawerCount:
        'No templates match this drawer count ({{drawers}}). Only templates with the same drawer count can be applied.',
    templateSaved: 'Template saved',
    templateApplied: 'Template applied',
    templateImported: 'Template imported',
    templateDeleted: 'Template deleted',
    templateDeleteTitle: 'Delete template',
    templateDeleteMessage: 'This permanently removes the template.',
    templateImportUnresolved: 'Imported, but some foams were not found and skipped: {{names}}',
    templateImportInvalid: 'That file is not a valid template.',
}

export default en
